export default "__VITE_ASSET__DjsBdfj6__"